/* @jsx h */
import { defineComponent, Fragment, h } from "vue";
import { useGroupAuth } from "@app/vue/providers/GroupAuth";
import { NavLink } from "../LayoutComponents/Navbar/NavLink";

type GroupNavItemsProps = {
  onNavigate?: () => void;
};

export const GroupNavItems = defineComponent<GroupNavItemsProps>({
  name: "GroupNavItems",
  props: ["onNavigate"],
  setup(props) {
    const { isGroupAdmin } = useGroupAuth();
    const comparatorFn = (routePath: string, path: string) =>
      routePath.startsWith(path);

    return () => (
      <Fragment>
        <NavLink
          to="/group/dashboard"
          icon="dashboard"
          title="admin.common.dashboard"
          comparatorFn={comparatorFn}
          onClick={props.onNavigate}
        />
        <NavLink
          to="/group/loyalty"
          icon="social_leaderboard"
          title="nav.labels.loyalty"
          comparatorFn={comparatorFn}
          onClick={props.onNavigate}
        />
        {isGroupAdmin.value ? (
          <NavLink
            to="/group/settings"
            icon="settings"
            title="admin.common.settings"
            comparatorFn={comparatorFn}
            onClick={props.onNavigate}
          />
        ) : null}
      </Fragment>
    );
  },
});
